export default __webpack_public_path__ + "static/media/call.a1804012.svg";